import React, { Component } from 'react';
import AdminPage from './AdminPage';
import {
  firebaseAuth,
  firebaseDb,
} from '../lib/firebase/firebase';
class Error404 extends Component {
  componentDidMount(){
  }
  onLogout(){
    firebaseAuth.signOut();
  }
  render() {
    return (
      <AdminPage user={this.props.user}>
        <div className="row">
          <div className="col-md-12 col-sm-12 text-center">
            <h1 className="text-center">Are you lost?</h1>
            <a href="#" onClick={this.onLogout.bind(this)} className={"btn btn-sm btn-primary"}>Get me ot of here!</a>
          </div>
        </div>
      </AdminPage>
    );
  }
}

export default Error404;



// WEBPACK FOOTER //
// ./src/views/Error404.js